import React from 'react'
import Help from './help-page/Help'

const Helpsec = () => {
  return (
     <Help/>
  )
}

export default Helpsec